<template>
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
         <el-form-item prop="nameEn">
                <el-input size="small" v-model="searchForm.nameEn" placeholder="英文名称" clearable></el-input>
         </el-form-item>
         <el-form-item prop="nameCn">
                <el-input size="small" v-model="searchForm.nameCn" placeholder="中文名称" clearable></el-input>
         </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>

     <div class="bg-white top">
      <div><span>该模块是功能空间，用于套餐空间显示相关大小和布局或其他，使用时需要在功能空间内容中关联相关功能空间</span></div>
        <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
          <template #buttons>
            <el-button v-if="hasPermission('unmspace:cecUnmFunctionalSpace:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
            <!-- <el-button v-if="hasPermission('unmspace:cecUnmFunctionalSpace:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmFunctionalSpaceTable && $refs.cecUnmFunctionalSpaceTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <el-button v-if="hasPermission('unmspace:cecUnmFunctionalSpace:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmFunctionalSpaceTable && $refs.cecUnmFunctionalSpaceTable.getCheckboxRecords().length === 0" plain>删除</el-button>
          </template>
          <template #tools>
            <vxe-button
    		  type="default"
    		  title="下载导入模板"
    		  v-if="hasPermission('unmspace:cecUnmFunctionalSpace:import')"
    		  class="el-icon-document m-r-12"
    		  @click="downloadTpl()"
    		  circle
            >
            </vxe-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 98px);">
        <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmFunctionalSpaceTable"
            show-header-overflow
            show-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `功能空间管理数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '功能空间管理数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
            <!-- <vxe-column type="seq" width="40"></vxe-column> -->
            <vxe-column type="checkbox"  width="40px"></vxe-column>
            <vxe-column
        field="sort"
        align="center"
        width="50"
        title="排序">
      </vxe-column>
      <vxe-column
        field="nameCn"
        align="center"
        title="中文名称">
            <template slot-scope="scope">
              <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmspace:cecUnmFunctionalSpace:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
              <el-link  type="primary" :underline="false" v-if="hasPermission('unmspace:cecUnmFunctionalSpace:view')"  @click="view(scope.row.id)">{{scope.row.nameCn}}</el-link>
              <span v-else>{{scope.row.nameCn}}</span>
            </template>
      </vxe-column>
      <vxe-column
        field="nameEn"
        align="center"
        title="英文名称">
      </vxe-column>
      <vxe-column
        field="defaultValue.nameEn"
        align="center"
        title="默认值">
            <template slot-scope="scope">
                {{scope.row.defaultValue && scope.row.defaultValue.nameEn}}
            </template>
      </vxe-column>
      <vxe-column
          field="contentLis"
          width="80"
          align="center"
          title="涉及内容">
          <template #default="{ row }">
            <PopoverTipList
                  v-if="row.contentLis && row.contentLis.length > 0 "
                  labelValue = 'id'
                  tableType = "length"
                  tableHeight = '500px'
                  boxWidth="400"
                  :imageDisabled="true"
                  :columns="[
                    {
                      prop: 'nameCn',
                      label: '中文名称'
                    },
                    {
                      prop: 'nameEn',
                      label: '英文名称'
                    }
                  ]"
                  :selectArray="row.contentLis"
                ></PopoverTipList>
                <span v-else>-</span>
              </template>
          </vxe-column>
      <vxe-column
        fixed="right"
        align="center"
        width="200"
        title="操作">
        <template  slot-scope="scope">
          <el-button v-if="hasPermission('unmspace:cecUnmSpanceContent:edit')" type="text" size="small" @click="showRight(scope.row)">管理键值</el-button>
          <!-- <el-button v-if="hasPermission('unmspace:cecUnmFunctionalSpace:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button> -->
          <!-- <el-button v-if="hasPermission('unmspace:cecUnmFunctionalSpace:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button> -->
          <!-- <el-button v-if="hasPermission('unmspace:cecUnmFunctionalSpace:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button> -->
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager>
    </div>
    </div>
    <el-drawer
      size = "700px"
      :title="`${this.drawerTitle}`"
      :visible.sync="rightVisible"
      direction="rtl">
      <CecUnmSpanceContentListNoForm  ref="cecUnmFunctionalSpaceForm" @closeRight="closeRight"></CecUnmSpanceContentListNoForm>
    </el-drawer>
        <!-- 弹窗, 新增 / 修改 -->
        <CecUnmFunctionalSpaceForm  ref="cecUnmFunctionalSpaceForm" @refreshDataList="refreshList"></CecUnmFunctionalSpaceForm>
  </div>
</template>

<script>
  import CecUnmFunctionalSpaceForm from './CecUnmFunctionalSpaceForm'
  import CecUnmSpanceContentListNoForm from './CecUnmSpanceContentListNoForm'
  import cecUnmFunctionalSpaceService from '@/api/unmspace/cecUnmFunctionalSpaceService'
  import PopoverTipList from '@/components/popoverTip/indexList.vue'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          nameCn: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'a.create_date', asc: true }]
        },
        loading: false,
        rightVisible: false,
        drawerTitle: ''
      }
    },
    components: {
      CecUnmFunctionalSpaceForm,
      CecUnmSpanceContentListNoForm,
      PopoverTipList
    },
    activated () {
      this.refreshList()
    },
    methods: {
      showRight (row) {
        console.log(row)
        this.rightVisible = true
        this.$nextTick(() => {
          this.$refs.cecUnmFunctionalSpaceForm.refreshList(row.id)
          this.drawerTitle = row.nameCn + '键值管理'
        })
      },
      closeRight () {
        this.rightVisible = false
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmFunctionalSpaceService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records.map(item => {
            item.contentLis = item.contentLis.map(citem => {
              citem.fileUrl = citem.coverImage ? process.env.VUE_APP_SERVER_URL + citem.coverImage.filePath : ''
              return citem
            })
            return item
          })
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'a.create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmFunctionalSpaceForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmFunctionalSpaceTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmFunctionalSpaceForm.init('edit', id)
      },
      // 查看
      view (id) {
        this.$refs.cecUnmFunctionalSpaceForm.init('view', id)
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmFunctionalSpaceTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmFunctionalSpaceService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmFunctionalSpaceService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmFunctionalSpaceService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmFunctionalSpaceService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>
<style scoped lang="less">
.el-drawer__header {
  margin-bottom: 10px !important;
}
</style>
